import { Pipe, PipeTransform } from '@angular/core';
import { Observable, of } from 'rxjs';

@Pipe({ name: 'decimalAsyncPipe' })
export class DecimalAsyncPipe implements PipeTransform {
  transform(value: any, decimalPlaces: number): Observable<any> {
    if (!!value && !isNaN(value)) {
      const result = Number(parseFloat(value).toFixed(decimalPlaces));
      return of(result);
    } else {
      return of(value);
    }
  }
}
